import React from 'react';

import Text from 'antd/es/typography/Text';
import { strings } from '../../localization';

function NoDataEnergyFlow() {
    return (
        <div style={{marginBottom: 25, marginTop: 5, marginLeft: 10, marginRight: 10}}>
            <p style={{
                fontSize: 14,
                color: '#660000',
                fontWeight: 'bold',
                textAlign: 'center',
                marginBottom: 15,
            }}>
                {strings.dashboard.noDataEnergyFlow}
            </p>
            <Text> {strings.dashboard.noDataEnergyFlowHelp} </Text>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                <div
                    style={{
                        width: 16,
                        minWidth: 16,
                        height: 16,
                        borderRadius: 8,
                        marginLeft: 10,
                        marginTop: 4,
                        marginRight: 5,
                        backgroundColor: '#333333',
                    }}
                />
                {strings.dashboard.noDataEnergyFlowLedGrey}
            </div>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                <div
                    style={{
                        width: 16,
                        minWidth: 16,
                        height: 16,
                        borderRadius: 8,
                        marginLeft: 10,
                        marginTop: 4,
                        marginRight: 5,
                        backgroundColor: '#4488FF',
                    }}
                />
                {strings.dashboard.noDataEnergyFlowLedBlue1}
            </div>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                <div
                    style={{
                        width: 16,
                        minWidth: 16,
                        height: 16,
                        borderRadius: 8,
                        marginLeft: 10,
                        marginTop: 4,
                        marginRight: 5,
                        backgroundColor: '#4488FF',
                    }}
                />
                {strings.dashboard.noDataEnergyFlowLedBlue2}
            </div>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                <div
                    style={{
                        width: 16,
                        minWidth: 16,
                        height: 16,
                        borderRadius: 8,
                        marginLeft: 10,
                        marginTop: 4,
                        marginRight: 5,
                        backgroundColor: '#00AA00',
                    }}
                />
                {strings.dashboard.noDataEnergyFlowLedGreen}
            </div>
        </div>
    );
}

export default NoDataEnergyFlow;
